module.exports = __webpack_public_path__ + "img/leatherwork.07ca2946.png";